import { fetch } from './api-wrapper';

// Keep authentication in the existing wrapper. Query-only DELETE avoids sending
// a body, which the comments API deliberately rejects.
export const commentsRequest = (path, method = 'GET', payload = {}) => new Promise((resolve, reject) => {
  fetch(path, method, payload, (response) => resolve(response.data), reject,
    false, null, 0, { queryOnly: method === 'DELETE' });
});

export const commentScopeKey = ({ subject }) => `${subject.type}:${subject.id}:${subject.line_id || 'invoice'}`;

export const commentErrorKey = (error) => {
  const status = error?.response?.status;
  if (status === 403 || status === 404) return 'error_comments_access';
  if (status === 409) return 'error_comments_conflict';
  return 'error_comments_unavailable';
};

// These records have a permanent server-owned subject. Older documents stay on
// their existing path until the separate migration; API errors never switch paths.
export const isInvoiceCommentsEnabled = (invoice) => process.env.REACT_APP_COMMENTS_ENABLED === 'true'
  && Number.isInteger(invoice?.json?._line_items_revision);
